import Crud from '../components/Admin/Crud'
import Add from '../components/Admin/Add'
import Edit from '../components/Admin/Edit'
import View from '../components/Admin/View'

let routes = {
    path: '/admins',
    component: resolve => require(['../components/layout/AdminApp'], resolve),
    children: [
        {
            path: '/admins',
            name: 'Administradores',
            component: Crud
        },
        {
            path: '/admins/add',
            name: 'Novo Administrador',
            component: Add
        },
        {
            path: '/admins/edit/:id',
            name: 'Editar Administrador',
            component: Edit
        },
        {
            path: '/admins/view/:id',
            name: 'Administrador',
            component: View
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/admin.js